import type { FetchFunction } from '#layers/base/utils/api-fetch';
import { useRuntimeConfig } from '#app/nuxt';
import { createApiFetch } from '#layers/base/utils/api-fetch';

/** Returns a fetch function scoped to system API endpoints. */
export function useSystemFetch(): FetchFunction {
	const runtimeConfig = useRuntimeConfig();

	return createApiFetch({ baseURL: runtimeConfig.public.api }) as FetchFunction;
}
